import { ILocation } from 'src/models/ILocation';
import { ITag } from 'src/store/reducers/tag/types';

export class Location implements ILocation {
  name = '';
  review_link = '';
  country = '';
  tags = [] as ITag[];
}
